import React from 'react';
import styles from './guidanceItemCard.scss';

interface Props {
  children: any;
}

const GuidancePreviewImage: React.FC<Props> = ({ children }) => {
  return (
    <>
      <div className={styles.guidanceImageHeader}>
        <div className={styles.circle} />
        <div className={styles.circle} />
        <div className={styles.circle} />
      </div>
      <div className={styles.guidanceImage}>{children}</div>
    </>
  );
};
export default GuidancePreviewImage;
